









import {Component, Prop, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import RacingFlagIcon from '../../../../assets/svg/racing-flag.svg';

@Component({
  name: "ControlPanelTimer",
  components: { RacingFlagIcon }
})
export default class ControlPanelTimer extends Vue {
  @Prop() start: DateTime;
  @Prop() end: DateTime;

  timerId: number;
  seconds = 0;
  hasStopped = false;
  hasStarted = false;
  startLocal: DateTime | null = null;
  endLocal: DateTime | null = null;

  get showTimer(): boolean {
    return this.start && this.end && this.hasStarted && !this.hasStopped;
  }

  get formattedTime(): string {
    const h = Math.floor(this.seconds / 3600),
          m = Math.floor(this.seconds % 3600 / 60),
          s = Math.floor(this.seconds % 3600 % 60);
    const valuesToShow = [m, s];
    h > 0 && valuesToShow.unshift(h);

    return valuesToShow.map(item => ('0' + item).slice(-2)).join(':');
  }

  mounted() {
    if(this.start && this.end) {
      this.startLocal = this.start ? this.start : DateTime.local();
      this.endLocal = this.end ? this.end : DateTime.local();
      this.setHasStarted();
      this.initSeconds();
      this.timerId = window.setInterval(this.increaseTime, 1000)
    }
  }

  initSeconds(): void {
    this.seconds = this.end.diff(DateTime.local(), "seconds").seconds;
  }

  increaseTime(): void {
    this.seconds--;

    this.setHasStarted();
  }

  setHasStarted() {
    if (!this.hasStarted && this.startLocal && this.startLocal <= DateTime.local()) {
      this.hasStarted = true;
    }
  }

  stopInterval(): void {
    clearInterval(this.timerId);
    this.hasStopped = true;
  }

  destroyed() {
    this.stopInterval();
  }
}
